module.exports = __webpack_public_path__ + "static/media/bg-image-16.4b082504.jpg";